export const notNull = (val) => val !== null && val !== undefined;

export const isNull = (val) => !notNull(val);